import { useState, useEffect, useCallback } from 'react';
import { getYearInfoAgreement36Data, getDetailStaffAgreement36 } from 'api/agreement36';
import useToastNotification from 'hooks/useToastNotification';
import moment from 'moment';
import { useOrgTreesOptionsForAgreements} from 'hooks/useOrgTreesOptions';
import { Attend36AgreementsAlertData } from './../type';
import useGetDetailRole from 'hooks/useGetDetailRole';
import { functionCode } from 'const';
import { OptionType } from 'components/atoms/Select';
import { getSetting36AgreementById, getSetting36AgreementByYearAndStaffCode } from 'api/master36Agreement';
import { useAgreementsOptionsByYear } from 'hooks/useAgreementsOptions';

const { errorNotification, successNotification } = useToastNotification();

export type YearlyAgreement36Data = {
  agreementsId: string;
  targetYear: number;
  applyStartMonth: Date;
  yearOvertimeList: Array<number>|null;
  yearOvertimeHourList: Array<number>|null;
  monthlyOverConditionsCountList: Array<number>|null;
  monthOverConditionsHour: number;
  monthlyOverAndHolidayTimeHour: number;
}
export type YearlyInfoAgreement36Data = {
  staffCode: string;
  staffName: string;
  orgCode: string;
  orgName: string;
  overTimeYear: number;
  overTimeYearHour: number;
  aveOverAlertCnt: number;
  overTimeAlertCnt: number;
  overHolidayTimeAlertCnt: number;
  overTimeYearFlag: number;
  aveOverFlag: number;
  overTimeFlag: number;
  overHolidayTimeFlag: number;
  agreementsId: string
}
const initYearlyAgreement36Data: YearlyAgreement36Data = {
  agreementsId: '',
  targetYear: 0,
  applyStartMonth: new Date(),
  yearOvertimeList: null,
  yearOvertimeHourList: null,
  monthlyOverConditionsCountList: null,
  monthOverConditionsHour: 0,
  monthlyOverAndHolidayTimeHour: 0,
}

const testYearlyAgreement36Data: YearlyAgreement36Data = {
  agreementsId: "84518214-de1d-4750-9314-38136d1e3157",
  targetYear: 2020,
  applyStartMonth: new Date(),
  yearOvertimeList: [14400,30000,43200],
  yearOvertimeHourList: [240,500,720],
  monthlyOverConditionsCountList: [1,3,4,6],
  monthOverConditionsHour:40,
  monthlyOverAndHolidayTimeHour: 100
}

export const useYearlyAgreement36Form = () => {
  const staffCode = sessionStorage.getItem('loginUser.staffCode') || "";
  const [orgCode, setOrgCode] = useState(sessionStorage.getItem('yearlyAgreement36.orgCode') || sessionStorage.getItem('loginUser.orgCode') || '');
  const [yearlyAgreement36Data, setYearlyAgreement36Data] = useState<YearlyAgreement36Data>(initYearlyAgreement36Data);
  const [yearlyInfoData, setYearlyInfoData] = useState<YearlyInfoAgreement36Data[]>();
  const [staffDetail, setStaffDetail] = useState<Attend36AgreementsAlertData[]>();
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [overTime, setOverTime] = useState(Number(sessionStorage.getItem('yearlyAgreement36.yearlyOverTime')) || 0 );
  const [overTimeOptions, setOverTimeOptions] = useState<Array<OptionType>>([]);
  const [averageOverTime, setAverageOverTime] = useState(Number(sessionStorage.getItem('yearlyAgreement36.averageOverTime')) || 0 );
  const [averageOverTimeOptions, setAverageOverTimeOptions] = useState<Array<OptionType>>([]);
  const [overCount, setOverCount] = useState(Number(sessionStorage.getItem('yearlyAgreement36.overCount')) || 0 );
  const [overCountOptions, setOverCountOptions] = useState<Array<OptionType>>([]);

  const [isLoading, setIsLoading] = useState(false);
  const [applyYear, setApplyYear] = useState(Number(sessionStorage.getItem('yearlyAgreement36.applyYear')) || new Date().getFullYear());
  const [applyStartMonth, setApplyStartMonth] = useState(new Date());
  const { detailRole } = useGetDetailRole(setIsLoading, functionCode.agreement36);
  const [underFlag, setUnderFlag] = useState(0);
  const [agreementsId, setAgreementsId] = useState(sessionStorage.getItem('yearlyAgreement36.agreementsId') || '');
  const agreementsOptions = useAgreementsOptionsByYear(applyYear, functionCode.agreement36);
  const orgTreesOptions = useOrgTreesOptionsForAgreements(true, functionCode.agreement36, agreementsId? agreementsId : '', moment([applyYear]).startOf('year').format('YYYY-MM-DD'), moment([applyYear]).endOf('year').format('YYYY-MM-DD'));
  
  const [flag, setFlag] = useState(false)

  const fetchYearInfo = async (applyDate: Date, ) => {
    let params = {
      targetMonth: applyDate? moment(applyDate).format('YYYY/MM/01') : moment([applyYear]).startOf('year').format('YYYY/MM/01'),
      orgCode: detailRole.accessRange === 0 ? '' : orgCode,
      yearOverTime: overTime,
      averageOverTime: averageOverTime,
      overConditionsCount: overCount,
      underFlag,
      agreementsId: agreementsId
    }
    try {
      if (flag) {
        setIsLoading(true);
        getYearInfoAgreement36Data(params).then((response: any) => {
          setIsLoading(false);
          setYearlyInfoData(response);
        }).catch((error: any) => {
          setYearlyInfoData(undefined)
          setIsLoading(false);
          if (error.status === 400) {
            if (error.data.errors && error.data.errors.length > 0) {
              errorNotification(
                error.data.errors.map((x: any) => x.defaultMessage)
              );
            } else if (error.data.defaultMessage) {
              errorNotification(error.data.defaultMessage);
            } else {
              errorNotification(error.data.message);
            }
          } else {
            errorNotification("サーバー側でエラーが発生しました。");
          }  
        })
      } else {
        setYearlyInfoData([]);
      }
    } catch (error) {
      setYearlyInfoData(undefined);
      errorNotification('サーバー側でエラーが発生しました。');
      setIsLoading(false);
    } finally {
      setIsLoading(false);
      if (sessionStorage.getItem('yearlyAgreement36.agreementsId')) {
        sessionStorage.removeItem('yearlyAgreement36.agreementsId');
      }
      if (sessionStorage.getItem('yearlyAgreement36.applyYear')) {
        sessionStorage.removeItem('yearlyAgreement36.applyYear');
      }
      if (sessionStorage.getItem('yearlyAgreement36.orgCode')) {
        sessionStorage.removeItem('yearlyAgreement36.orgCode');
      }
      if (sessionStorage.getItem('yearlyAgreement36.underFlag')) {
        sessionStorage.removeItem('yearlyAgreement36.underFlag');
      }
      if (sessionStorage.getItem('yearlyAgreement36.yearlyOverTime')) {
        sessionStorage.removeItem('yearlyAgreement36.yearlyOverTime');
      }
      if (sessionStorage.getItem('yearlyAgreement36.averageOverTime')) {
        sessionStorage.removeItem('yearlyAgreement36.averageOverTime');
      }
      if (sessionStorage.getItem('yearlyAgreement36.overCount')) {
        sessionStorage.removeItem('yearlyAgreement36.overCount');
      }
    }

  };

  const fetchDataDetailStaff = useCallback(async (staffCode: string, id: string) => {
    try {
      setIsLoading(true);
      getDetailStaffAgreement36(staffCode, id).then((response: any) => {
        setStaffDetail(response);        
      }).catch((error: any) => {
        if (error.status === 400) {
          if (error.data.errors && error.data.errors.length > 0) {
            errorNotification(
              error.data.errors.map((x: any) => x.defaultMessage)
            );
          } else if (error.data.defaultMessage) {
            errorNotification(error.data.defaultMessage);
          } else {
            errorNotification(error.data.message);
          }
        } else {
          errorNotification("サーバー側でエラーが発生しました。");
        }  
      }).finally(() => {
        setIsLoading(false);
      })
    } catch (error) {
      errorNotification('サーバー側でエラーが発生しました。');
    } finally{
      setIsLoading(false);
    }
  }, []);

  const fetchData = useCallback(async () => {
    setIsLoading(true);
    setFlag(false);
    try {
      getSetting36AgreementById(agreementsId? agreementsId : '').then((response: any) => {
        setYearlyAgreement36Data(response);
        if(!response.agreementsId){
          setAgreementsId('');
          setOverTimeOptions([{label:'指定なし', value:'0'}]);
          setOverTime(0);
          setAverageOverTimeOptions([{label:'指定なし', value:'0'}]);
          setAverageOverTime(0);
          setOverCountOptions([{label:'指定なし', value:'0'}]);
          setOverCount(0);
        } else {
          let overTimeOp = response.yearOvertimeHourList?.map((item: any) => ({
            value: String(item * 60),
            label: String(item)+'時間を超過',
          }));
          if (overTimeOp) {
            overTimeOp.unshift({label:'指定なし', value:'0'})
            setOverTimeOptions(overTimeOp);
            setOverTime(getValueRadio(overTime, response.yearOvertimeList));
          } else {
            setOverTimeOptions([{label:'指定なし', value:'0'}]);
            setOverTime(0);
          }

          let averageTimeOp = response.averageOvertimeHourList?.map((item: any) => ({
            value: String(item * 60),
            label: String(item)+'時間を超過',
          }));
          if (averageTimeOp) {
            averageTimeOp.unshift({label:'指定なし', value:'0'})
            setAverageOverTimeOptions(averageTimeOp);
            setAverageOverTime(getValueRadio(averageOverTime, response.averageOvertimeList));
          } else {
            setAverageOverTimeOptions([{label:'指定なし', value:'0'}]);
            setAverageOverTime(0);
          }

          let overCountOp = response.monthlyOverConditionsCountList?.map((item: any) => ({
            value: String(item),
            label: String(item)+'回超過',
          }));
          if (overCountOp) {
            overCountOp.unshift({label:'指定なし', value:'0'})
            setOverCountOptions(overCountOp);
            setOverCount(getValueRadio(overCount, response.monthlyOverConditionsCountList));
          } else {
            setOverCountOptions([{label:'指定なし', value:'0'}]);
            setOverCount(0);
          }
          setFlag(true);
        }
      }).catch((error: any) => {
        if (error.status === 400) {
          if (error.data.errors && error.data.errors.length > 0) {
            errorNotification(
              error.data.errors.map((x: any) => x.defaultMessage)
            );
          } else if (error.data.defaultMessage) {
            errorNotification(error.data.defaultMessage);
          } else {
            errorNotification(error.data.message);
          }
        } else {
          errorNotification("サーバー側でエラーが発生しました。");
        }  
      }).finally(() => {
        setFlag(true);
      })
    } catch (error) {
      errorNotification('サーバー側でエラーが発生しました。');
      setIsLoading(false);
    } finally{
      setIsLoading(false);
    }
  }, [agreementsId]);

  const fetchDataInit = useCallback(async () => {
    setIsLoading(true);
    let params = {
      targetYear: applyYear,
    }
    try {
      getSetting36AgreementByYearAndStaffCode(params).then((response: any) => {
        if(!response){
          errorNotification('36協定アラートマスタが登録されていません');
          setAgreementsId(response.agreementsId);
        }
        setApplyStartMonth(response.applyStartMonth);
        setYearlyAgreement36Data(response);
        setAgreementsId(response.agreementsId);
      }).catch((error: any) => {
        if (error.status === 400) {
          if (error.data.errors && error.data.errors.length > 0) {
            errorNotification(
              error.data.errors.map((x: any) => x.defaultMessage)
            );
          } else if (error.data.defaultMessage) {
            errorNotification(error.data.defaultMessage);
          } else {
            errorNotification(error.data.message);
          }
        } else {
          errorNotification("サーバー側でエラーが発生しました。");
        }  
      }).finally(() => {
      })
    } catch (error) {
      errorNotification('サーバー側でエラーが発生しました。');
      setIsLoading(false);
    } finally{
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    if(flag){
      fetchYearInfo(applyStartMonth, );
    }
  }, [flag, orgCode, underFlag, overTime, averageOverTime, overCount])

  useEffect(() => {
    if (agreementsOptions && agreementsOptions.length && agreementsId !== '') {
      setAgreementsId(agreementsOptions.some(b => b.value === agreementsId) ? agreementsId : agreementsOptions[0].value);
      fetchData();
    } else if (agreementsOptions && agreementsOptions.length){
      fetchDataInit();
    } else {
      setOverTimeOptions([{label:'指定なし', value:'0'}]);
      setOverTime(0);
      setAverageOverTimeOptions([{label:'指定なし', value:'0'}]);
      setAverageOverTime(0);
      setOverCountOptions([{label:'指定なし', value:'0'}]);
      setOverCount(0);
      setFlag(false);
      setYearlyInfoData([]);
    }
  }, [agreementsOptions]);

  useEffect(() => {
    fetchData();
}, [agreementsId]);

  
  const handleOpenDetail = (staffCode: string, id: string) => {
    setIsOpenModal(true);
    fetchDataDetailStaff(staffCode, id);
  }

  const getValueRadio = (curVal: number, optionList : Array<number>|null) => {
    if (optionList !== null) {
      for (let i = 0; i < optionList.length; i++) {
        if (optionList[i] === curVal) {
          return optionList[i];
        }
      }
      return optionList[optionList.length - 1];
    }
    return 0;
  }


  return {
    isLoading,
    applyYear,
    setApplyYear,
    staffCode,
    orgCode,
    setOrgCode,
    orgTreesOptions,
    yearlyAgreement36Data,
    yearlyInfoData,
    staffDetail,
    isOpenModal,
    setIsOpenModal,
    handleOpenDetail,
    underFlag,
    setUnderFlag,
    detailRole,
    agreementsId,
    setAgreementsId,
    agreementsOptions,
    overTime,
    setOverTime,
    overTimeOptions,
    averageOverTime,
    setAverageOverTime,
    averageOverTimeOptions,
    overCount,
    setOverCount,
    overCountOptions,
  };
};

export default useYearlyAgreement36Form;
